"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waypointsDataGetter = exports.storingPlacesCellDataGetter = exports.statusCellDataGetter = exports.startPoiTimeCellDataGetter = exports.startPoiCellDataGetter = exports.sharedWithCellDataGetter = exports.sharedByCellDataGetter = exports.serviceProviderPortalIdCellDataGetter = exports.scheduledStartTimeCellDataGetter = exports.scheduledEndTimeCellDataGetter = exports.realStartTimeCellDataGetter = exports.realEndTimeCellDataGetter = exports.railwayUndertakingCellDataGetter = exports.nameCellDataGetter = exports.loadedCellDataGetter = exports.haulerPortalIdCellDataGetter = exports.externalIdCellDataGetter = exports.etaCellDataGetter = exports.endPoiTimeCellDataGetter = exports.endPoiCellDataGetter = exports.earliestStartTimeCellDataGetter = exports["default"] = exports.customerPortalIdsCellDataGetter = exports.customerNameCellDataGetter = exports.assignedAlarmsCellDataGetter = exports.assetIdCellDataGetter = exports.actionsCellDataGetter = void 0;

var _react = _interopRequireDefault(require("react"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var assetIdCellDataGetter = function assetIdCellDataGetter(_ref) {
  var rowData = _ref.rowData;
  var _rowData$assetName = rowData.assetName,
      assetName = _rowData$assetName === void 0 ? '' : _rowData$assetName,
      appLicensePlate = rowData.appLicensePlate;

  if (appLicensePlate) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tourdriverApp",
      tagName: "span"
    });
  }

  return assetName;
};

exports.assetIdCellDataGetter = assetIdCellDataGetter;

var nameCellDataGetter = function nameCellDataGetter(_ref2) {
  var rowData = _ref2.rowData;
  var _rowData$name = rowData.name,
      name = _rowData$name === void 0 ? '' : _rowData$name,
      _rowData$segments = rowData.segments,
      segments = _rowData$segments === void 0 ? [] : _rowData$segments;
  return {
    name: name,
    segments: segments
  };
};

exports.nameCellDataGetter = nameCellDataGetter;

var haulerPortalIdCellDataGetter = function haulerPortalIdCellDataGetter(_ref3) {
  var _rowData$dataRequest;

  var rowData = _ref3.rowData;
  return ((_rowData$dataRequest = rowData.dataRequest) === null || _rowData$dataRequest === void 0 ? void 0 : _rowData$dataRequest.haulerPortalId) || null;
};

exports.haulerPortalIdCellDataGetter = haulerPortalIdCellDataGetter;

var earliestStartTimeCellDataGetter = function earliestStartTimeCellDataGetter(_ref4) {
  var rowData = _ref4.rowData;
  return rowData.earliestStartTime;
};

exports.earliestStartTimeCellDataGetter = earliestStartTimeCellDataGetter;

var scheduledStartTimeCellDataGetter = function scheduledStartTimeCellDataGetter(_ref5) {
  var rowData = _ref5.rowData;
  return rowData.scheduledStartTime;
};

exports.scheduledStartTimeCellDataGetter = scheduledStartTimeCellDataGetter;

var scheduledEndTimeCellDataGetter = function scheduledEndTimeCellDataGetter(_ref6) {
  var rowData = _ref6.rowData;
  return rowData.scheduledEndTime;
};

exports.scheduledEndTimeCellDataGetter = scheduledEndTimeCellDataGetter;

var realStartTimeCellDataGetter = function realStartTimeCellDataGetter(_ref7) {
  var rowData = _ref7.rowData;
  var startBy = rowData.startBy,
      date = rowData.realStartTime;
  return {
    startBy: startBy,
    date: date
  };
};

exports.realStartTimeCellDataGetter = realStartTimeCellDataGetter;

var realEndTimeCellDataGetter = function realEndTimeCellDataGetter(_ref8) {
  var rowData = _ref8.rowData;
  var stopBy = rowData.stopBy,
      date = rowData.realEndTime;
  return {
    stopBy: stopBy,
    date: date
  };
};

exports.realEndTimeCellDataGetter = realEndTimeCellDataGetter;

var externalIdCellDataGetter = function externalIdCellDataGetter(_ref9) {
  var rowData = _ref9.rowData;
  return rowData.externalId;
};

exports.externalIdCellDataGetter = externalIdCellDataGetter;

var statusCellDataGetter = function statusCellDataGetter(_ref10) {
  var rowData = _ref10.rowData;
  var status = rowData.status,
      wayPoints = rowData.wayPoints;

  if (wayPoints && wayPoints.length) {
    var startPoi = wayPoints.find(function (waypoint) {
      return waypoint.type === _constants.WAYPOINT_TYPES.START;
    });

    if (startPoi && startPoi.distanceToPoi) {
      return {
        status: status,
        distanceToPoi: startPoi.distanceToPoi
      };
    }
  }

  return {
    status: status
  };
};

exports.statusCellDataGetter = statusCellDataGetter;

var etaCellDataGetter = function etaCellDataGetter(_ref11) {
  var rowData = _ref11.rowData;
  var wayPoints = rowData.wayPoints;

  if (wayPoints && wayPoints.length) {
    var endPoi = wayPoints.find(function (waypoint) {
      return waypoint.type === _constants.WAYPOINT_TYPES.END;
    });

    if (endPoi && endPoi.estimatedTimeOfArrival) {
      return endPoi.estimatedTimeOfArrival;
    }
  }

  return null;
};

exports.etaCellDataGetter = etaCellDataGetter;

var assignedAlarmsCellDataGetter = function assignedAlarmsCellDataGetter(_ref12) {
  var rowData = _ref12.rowData;
  var _rowData$segments2 = rowData.segments,
      segments = _rowData$segments2 === void 0 ? [] : _rowData$segments2,
      _rowData$alarms = rowData.alarms,
      alarms = _rowData$alarms === void 0 ? [] : _rowData$alarms;
  return Array.from(new Set([].concat(_toConsumableArray(alarms), _toConsumableArray(segments.map(function (segment) {
    return segment.alarms;
  }).flat()))).values());
};

exports.assignedAlarmsCellDataGetter = assignedAlarmsCellDataGetter;

var startPoiTimeCellDataGetter = function startPoiTimeCellDataGetter(_ref13) {
  var rowData = _ref13.rowData;

  if (rowData.wayPoints && rowData.wayPoints.length) {
    var startWaypoint = rowData.wayPoints.find(function (waypoint) {
      return waypoint.type === _constants.WAYPOINT_TYPES.START;
    });

    if (startWaypoint && startWaypoint.plannedStartTime) {
      return startWaypoint.plannedStartTime;
    }
  }

  return null;
};

exports.startPoiTimeCellDataGetter = startPoiTimeCellDataGetter;

var endPoiTimeCellDataGetter = function endPoiTimeCellDataGetter(_ref14) {
  var rowData = _ref14.rowData;
  var _rowData$plannedEndTi = rowData.plannedEndTime,
      plannedEndTime = _rowData$plannedEndTi === void 0 ? null : _rowData$plannedEndTi;
  return plannedEndTime;
};

exports.endPoiTimeCellDataGetter = endPoiTimeCellDataGetter;

var startPoiCellDataGetter = function startPoiCellDataGetter(_ref15) {
  var rowData = _ref15.rowData;

  if (rowData.wayPoints && rowData.wayPoints.length) {
    var waypoint = rowData.wayPoints.find(function (wp) {
      return wp.type === _constants.WAYPOINT_TYPES.START;
    });

    if (waypoint && waypoint.poiId) {
      return waypoint;
    }
  }

  return '';
};

exports.startPoiCellDataGetter = startPoiCellDataGetter;

var endPoiCellDataGetter = function endPoiCellDataGetter(_ref16) {
  var rowData = _ref16.rowData;

  if (rowData.wayPoints && rowData.wayPoints.length) {
    var waypoint = rowData.wayPoints.find(function (wp) {
      return wp.type === _constants.WAYPOINT_TYPES.END;
    });

    if (waypoint && waypoint.poiId) {
      return waypoint;
    }
  }

  return '';
};

exports.endPoiCellDataGetter = endPoiCellDataGetter;

var waypointsDataGetter = function waypointsDataGetter(_ref17) {
  var rowData = _ref17.rowData;
  var wayPoints = rowData.wayPoints,
      timeOfLastBoxDataMessage = rowData.timeOfLastBoxDataMessage,
      status = rowData.status,
      assetType = rowData.assetType,
      realStartTime = rowData.realStartTime;
  return {
    wayPoints: wayPoints,
    timeOfLastBoxDataMessage: timeOfLastBoxDataMessage,
    status: status,
    assetType: assetType,
    realStartTime: realStartTime
  };
};

exports.waypointsDataGetter = waypointsDataGetter;

var sharedByCellDataGetter = function sharedByCellDataGetter(_ref18) {
  var rowData = _ref18.rowData;
  var owningPortal = rowData.owningPortal;
  return owningPortal && owningPortal.id || null;
};

exports.sharedByCellDataGetter = sharedByCellDataGetter;

var sharedWithCellDataGetter = function sharedWithCellDataGetter(_ref19) {
  var rowData = _ref19.rowData;
  var sharedWithPortals = rowData.sharedWithPortals;
  return sharedWithPortals[0] && sharedWithPortals[0].id || null;
};

exports.sharedWithCellDataGetter = sharedWithCellDataGetter;

var serviceProviderPortalIdCellDataGetter = function serviceProviderPortalIdCellDataGetter(_ref20) {
  var rowData = _ref20.rowData;
  var serviceProviderPortalId = rowData.serviceProviderPortalId;
  return serviceProviderPortalId || null;
};

exports.serviceProviderPortalIdCellDataGetter = serviceProviderPortalIdCellDataGetter;

var customerPortalIdsCellDataGetter = function customerPortalIdsCellDataGetter(_ref21) {
  var rowData = _ref21.rowData;
  var _rowData$customerPort = rowData.customerPortalIds,
      customerPortalIds = _rowData$customerPort === void 0 ? [] : _rowData$customerPort;
  return customerPortalIds;
};

exports.customerPortalIdsCellDataGetter = customerPortalIdsCellDataGetter;

var storingPlacesCellDataGetter = function storingPlacesCellDataGetter(_ref22) {
  var rowData = _ref22.rowData;
  var _rowData$additionalDa = rowData.additionalData,
      additionalData = _rowData$additionalDa === void 0 ? {} : _rowData$additionalDa;

  var _ref23 = additionalData !== null && additionalData !== void 0 ? additionalData : {},
      _ref23$greenyard = _ref23.greenyard,
      greenyard = _ref23$greenyard === void 0 ? {} : _ref23$greenyard;

  var _ref24 = greenyard !== null && greenyard !== void 0 ? greenyard : {},
      _ref24$waypointInfo = _ref24.waypointInfo,
      waypointInfo = _ref24$waypointInfo === void 0 ? [] : _ref24$waypointInfo;

  var waypointIds = waypointInfo.map(function (id) {
    return id.storingPlaces;
  });
  if (waypointIds.length > 0) return waypointIds.reduce(function (a, b) {
    return a + b;
  });
  return null;
};

exports.storingPlacesCellDataGetter = storingPlacesCellDataGetter;

var railwayUndertakingCellDataGetter = function railwayUndertakingCellDataGetter(_ref25) {
  var rowData = _ref25.rowData;
  var _rowData$additionalDa2 = rowData.additionalData,
      additionalData = _rowData$additionalDa2 === void 0 ? {} : _rowData$additionalDa2;

  var _ref26 = additionalData !== null && additionalData !== void 0 ? additionalData : {},
      _ref26$railInfo = _ref26.railInfo,
      railInfo = _ref26$railInfo === void 0 ? {} : _ref26$railInfo;

  var _ref27 = railInfo !== null && railInfo !== void 0 ? railInfo : {},
      _ref27$railwayUnderta = _ref27.railwayUndertaking,
      railwayUndertaking = _ref27$railwayUnderta === void 0 ? '' : _ref27$railwayUnderta;

  if (railwayUndertaking.length > 0) {
    return railwayUndertaking;
  }

  return '';
};

exports.railwayUndertakingCellDataGetter = railwayUndertakingCellDataGetter;

var loadedCellDataGetter = function loadedCellDataGetter(_ref28) {
  var rowData = _ref28.rowData;
  var _rowData$loaded = rowData.loaded,
      loaded = _rowData$loaded === void 0 ? null : _rowData$loaded;

  if (loaded) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tour.loaded",
      tagName: "span"
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.notLoaded",
    tagName: "span"
  });
};

exports.loadedCellDataGetter = loadedCellDataGetter;

var customerNameCellDataGetter = function customerNameCellDataGetter(_ref29) {
  var rowData = _ref29.rowData;
  var _rowData$additionalDa3 = rowData.additionalData,
      additionalData = _rowData$additionalDa3 === void 0 ? {} : _rowData$additionalDa3;

  var _ref30 = additionalData !== null && additionalData !== void 0 ? additionalData : {},
      _ref30$railInfo = _ref30.railInfo,
      railInfo = _ref30$railInfo === void 0 ? {} : _ref30$railInfo;

  var _ref31 = railInfo !== null && railInfo !== void 0 ? railInfo : {},
      _ref31$customerName = _ref31.customerName,
      customerName = _ref31$customerName === void 0 ? '' : _ref31$customerName;

  if (customerName.length > 0) {
    return customerName;
  }

  return '';
};

exports.customerNameCellDataGetter = customerNameCellDataGetter;

var actionsCellDataGetter = function actionsCellDataGetter(_ref32) {
  var rowData = _ref32.rowData,
      columnData = _ref32.columnData;
  return {
    tourStatus: columnData.tourStatus,
    onAssetRequestClick: function onAssetRequestClick() {
      return columnData.onAssetRequestClick(rowData.id);
    },
    useAsTemplate: function useAsTemplate() {
      return columnData.useAsTemplate(rowData.id);
    },
    onReportExportClicked: function onReportExportClicked() {
      return columnData.onReportExportClicked(rowData.id);
    },
    onDetailsClick: function onDetailsClick() {
      return columnData.onDetailsClick(rowData.id);
    },
    onEditClick: function onEditClick() {
      return columnData.onEditClick(rowData.id);
    },
    onDeleteClick: function onDeleteClick() {
      return columnData.onDeleteClick(rowData.id);
    },
    onTerminateClick: function onTerminateClick() {
      return columnData.onTerminateClick(rowData.id);
    },
    onStartClick: function onStartClick() {
      return columnData.onStartClick(rowData.id);
    },
    onCreateLinkClick: function onCreateLinkClick() {
      return columnData.onCreateLinkClick(rowData.id);
    },
    onExportTransportOrderClick: function onExportTransportOrderClick() {
      return columnData.onExportTransportOrderClick(rowData.id);
    }
  };
};

exports.actionsCellDataGetter = actionsCellDataGetter;
var _default = null;
exports["default"] = _default;